export class URLUtils {
    public static getQueryValueFromWindowLocation(name: string, safe: string | null = null): string | null {
        const searchParams = new URLSearchParams(window.location.search);

        const value = searchParams.get(name);

        return value || safe;
    }
}
